import { gql } from 'graphql-tag';

export const GET_DEFAULT_EMPLOYEE_ACCOUNTS = gql`
  query Id4a5badf9c0fcfc2558d38da71c2e464d($companyId: ID!) {
    company
  }
`;

export const GET_DEFAULT_SUPPLIER_ACCOUNTS = gql`
  query Id387d2313f2f2f3f204841c37acc43104($companyId: ID!) {
    company
  }
`;

export const GET_EMPLOYEE_ACCOUNT = gql`
  query Id5b4bf3a51895e6f3b48cb5ab77455f83($companyId: ID!, $userId: String!) {
    company
  }
`;

export const GET_PAYABLES_COUNT = gql`
  query Idb7bc1b65ca20089cfbbb84c64487d082(
    $companyId: ID!
    $after: ID
    $filtersV2: JSON
  ) {
    company
  }
`;
